import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinOurTeam() {
  return <section data-section-id="240999" id="join-our-team" className="dark bg-background text-foreground py-16 px-4 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="relative isolate overflow-hidden rounded-3xl bg-primary px-6 py-20 text-center shadow-xl sm:px-16 sm:py-24">
          {}
          <svg className="absolute inset-0 -z-10 h-full w-full stroke-primary-foreground/10 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]" aria-hidden="true">
            <defs>
              <pattern id="alindi-pattern" width="60" height="60" patternUnits="userSpaceOnUse">
                <path d="M30 0L60 30L30 60L0 30Z" fill="none" strokeWidth="1.5" />
                <path d="M30 15L45 30L30 45L15 30Z" fill="none" strokeWidth="1.5" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#alindi-pattern)" />
          </svg>

          <h2 className="mx-auto max-w-2xl font-default text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl md:text-5xl">
            Join the Happy Paws Family
          </h2>
          <p className="mx-auto mt-6 max-w-xl font-default text-lg leading-8 text-primary-foreground/90">
            Are you passionate about animal care? We are looking for dedicated professionals to join our growing veterinary team and make a difference.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button asChild size="lg" className="h-14 rounded-lg bg-foreground px-8 text-base font-semibold text-background shadow-md hover:bg-foreground/90 transition-all">
              <Link to="/OurTeamPage">
                View Openings
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}